import { ClassWatcher, IntervalTimer } from "../Utility/utils";
import Flickity from "flickity";
import "flickity/dist/flickity.min.css";
import "flickity-as-nav-for";

const body = document.body;

const initializeBlock = function ($block) {
  // First, Determine which block we're in, and set the args accordingly.
  let slider;
  let isBackend = false;

  let args = {
    pageDots: false,
    prevNextButtons: false,
    cellAlign: "left",
    adaptiveHeight: false,
  };

  // For backend, ensure we're targeting the actual block.
  if (!!$block[0]) {
    $block = $block[0];
    // isBackend = true;
    // return; //no slider for back-end for now
  }

  /**
   *   Default Slider Block
   */
  if (!!$block.querySelector(".slider_block__slider")) {
    slider = $block.querySelector(".slider_block__slider");

    const $prevArrow = $block.querySelector(".slider_block__previous_arrow");
    const $nextArrow = $block.querySelector(".slider_block__next_arrow");

    var flkty = new Flickity(slider, args);

    initArrows($prevArrow, $nextArrow, flkty);

    const lazyLoadResize = () => {
      // get the next slide content, looking for a lazy loaded media block
      const slide = $block.querySelector(".slider_block__slide.is-selected");
      const image = slide.querySelector("img.lazy");
      if (!!image && !image.classList.contains("lazy-resized")) {
        image.classList.add("lazy-resized");
        flktyResize(flkty);
        window.dispatchEvent(new Event("resize"));
      }
    };

    flkty.on("change", lazyLoadResize);

    const images = slider.querySelectorAll("img");
    images.forEach((img) => {
      if (img.complete) {
        flktyResize(flkty);
      } else {
        img.removeEventListener("load", () => {
          flktyResize(flkty);
        });
        img.addEventListener("load", () => {
          flktyResize(flkty);
        });
      }
    });

    window.removeEventListener("resize", () => {
      flktyAddResizeClassToBody();
      flktyResize(flkty);
    });
    window.addEventListener("resize", () => {
      flktyAddResizeClassToBody();
      flktyResize(flkty);
    });
  }

  /**
   *   Quote Slider Block
   */
  if (!!$block.querySelector(".quote_slider__quotes")) {
    slider = $block.querySelector(".quote_slider__quotes");

    const $prevArrow = $block.querySelector(".quote_slider__arrow.left");
    const $nextArrow = $block.querySelector(".quote_slider__arrow.right");

    const subNav = $block.querySelector(".quote_slider__source_nav");

    // Update args
    const wrapAround = slider.querySelectorAll(".top_slide").length > 4;
    args.wrapAround = wrapAround;
    // adaptive height
    args.adaptiveHeight = true;

    var flkty = new Flickity(slider, args);

    initArrows($prevArrow, $nextArrow, flkty, wrapAround);

    // Set up sub-nav slider
    let subNavSlider = null;
    if (!!subNav) {
      subNavSlider = new Flickity(subNav, args);
    }

    // Autoplay with flikity doesn't reset timer on user interaction
    // which can cause very quick slide changes after a user implemented change.
    // We'll set up our own autoplay functionality.
    const autoPlay = $block.getAttribute("data-autoplay") == "true" ? true : false;
    const speed = $block.getAttribute("data-slide-speed");
    let autoPlayTimer = null;
    if (autoPlay) {
      autoPlayTimer = new IntervalTimer(() => {
        flkty.next(true);
      }, speed);
      autoPlayTimer.start();

      // Reset the timer when you land on a new slide
      flkty.on("settle", () => {
        autoPlayTimer.start();
      });

      // Couldn't get this working in time, could revisit.
      // Set up event watchers to pause on hover.
      // if(!slider.autoplayEvents){
      //   slider.autoplayEvents = true;
      //   slider.addEventListener('mouseenter', () => {
      //     autoPlayTimer.pause();
      //   });
      //   slider.addEventListener('mouseleave', () => {
      //     autoPlayTimer.resume();
      //   });
      // }
    }

    // Handle Progress Bar
    const slideCount = flkty.cells.length;
    let progress = (1 / slideCount) * 100;
    $block.style.setProperty("--progress", progress + "%");
    flkty.on("change", (index) => {
      progress = ((index + 1) / slideCount) * 100;
      $block.style.setProperty("--progress", progress + "%");
    });

    flkty.on("settle", () => {
      setTimeout(() => {
        flktyResize(flkty);
        flktyResize(subNavSlider);
      }, 50);
    });

    // Swiping the sub-nav doesn't change the main slider even with "asNavFor" set.
    // We'll do that manually
    subNavSlider.on("change", (index) => {
      if (index !== flkty.selectedIndex) {
        flkty.select(index);
      }
    });

    flkty.on("change", (index) => {
      if (index !== subNavSlider.selectedIndex) {
        subNavSlider.select(index);
      }
    });

    // Handle Logo Update
    flkty.on("change", (index) => {
      const logos = $block.querySelectorAll(".quote_slider__logo");
      const activeLogo = $block.querySelector(".quote_slider__logo.active");

      if (!!activeLogo) {
        activeLogo.setAttribute("aria-hidden", "true");
        activeLogo.classList.add("fading-out");
        activeLogo.classList.remove("active");
        setTimeout(() => {
          activeLogo.classList.remove("fading-out");
        }, 300);
      }

      const newActiveLogo = logos[index];
      newActiveLogo.setAttribute("aria-hidden", "false");
      newActiveLogo.classList.add("active");
    });

    window.removeEventListener("resize", () => {
      flktyResize(flkty);
      flktyResize(subNavSlider);
    });
    window.addEventListener("resize", () => {
      flktyResize(flkty);
      flktyResize(subNavSlider);
    });
  }
};

const toggleArrows = ($prevArrow, $nextArrow, flkty, wrapAround = false) => {
  $prevArrow.removeAttribute("disabled");
  $nextArrow.removeAttribute("disabled");

  if (!wrapAround) {
    if (flkty.selectedIndex === 0) {
      $prevArrow.setAttribute("disabled", true);
    }

    if (flkty.selectedIndex >= flkty.slides.length - 1) {
      $nextArrow.setAttribute("disabled", true);
    }
  }
};

const initArrows = ($prevArrow, $nextArrow, flkty, wrapAround = false) => {
  toggleArrows($prevArrow, $nextArrow, flkty, wrapAround);

  flkty.on("change", () => {
    toggleArrows($prevArrow, $nextArrow, flkty);
  });

  $prevArrow.addEventListener("click", (e) => {
    flkty.previous(true);
  });

  //set up next button
  $nextArrow.addEventListener("click", (e) => {
    flkty.next(true);
  });
};

// Ensure slider is sized correctly when images are loaded.
const flktyResize = (flktySlider) => {
  if (flktySlider) {
    flktySlider.resize();
    flktySlider.reposition();
  }
};

// Remove min-height css from images of sliders so the slider will resize
// properly when reducing screen width
let resizeDebouncer;
const flktyAddResizeClassToBody = () => {
  
  document.body.classList.add('window_resizing');

  clearTimeout(resizeDebouncer);
  resizeDebouncer = setTimeout(() => {
    document.body.classList.remove('window_resizing');
  }, 100);

}


// Initialize dynamic block preview (editor).
if (window.acf) {
  window.acf.addAction("render_block_preview/type=slider", initializeBlock);
  window.acf.addAction("render_block_preview/type=quote-slider", initializeBlock);
}

const InitializeSliders = () => {
  var sliders = document.querySelectorAll(".slider_block, .quote_slider");

  Array.prototype.forEach.call(sliders, function (el, i) {
    initializeBlock(el);
  });
};

export { InitializeSliders };
